import { render } from "./UsedBoat.vue?vue&type=template&id=98fcaaba"
import script from "./UsedBoat.vue?vue&type=script&lang=js"
export * from "./UsedBoat.vue?vue&type=script&lang=js"

import "./UsedBoat.vue?vue&type=style&index=0&id=98fcaaba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__